import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastItem } from '../types/ToastItem';

export interface ToastAction {
    toastPayload: ToastItem;
}

export interface NotifyState {
    toastQueue: ToastItem[];
    displayToast: ToastItem | null;
}

const initialState: NotifyState = {
    toastQueue: [],
    displayToast: null,
};

const notifySlice = createSlice({
    name: 'notify',
    initialState,
    reducers: {
        createToast: (state, action: PayloadAction<{ toastData: ToastItem }>) => {
            const { toastData } = action.payload;
            const hasPriority = !state.displayToast || toastData.type < state.displayToast.type;
            state.displayToast = hasPriority ? toastData : state.displayToast;
            state.toastQueue = !hasPriority ? [...state.toastQueue, toastData] : state.toastQueue;
        },
        dismissToast: state => {
            state.displayToast = state.toastQueue.slice(0, 1)[0] || null;
            state.toastQueue = state.toastQueue.slice(1);
        },
    },
});

export const { createToast, dismissToast } = notifySlice.actions;

export default notifySlice.reducer;
